import { OptionalPermissionActions } from 'src/definitions/custom-models';

export const canUpdate = (permission?: OptionalPermissionActions) => permission?.UPDATE === 'PERMIT';
export const canDelete = (permission?: OptionalPermissionActions) => permission?.DELETE === 'PERMIT';
